module.exports = __webpack_public_path__ + "static/media/hdd.ade80ece.svg";